import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import FixtureInputModel from '../models/FixtureInputModel';
import FixtureEvaluationInputModel from '../models/FixtureEvaluationInputModel';

interface FixtureEvaluationInputState {
    input: FixtureEvaluationInputModel,
    selectedFixtureId: string,
    showEvaluationInputPanel: boolean,
}

const initialState: FixtureEvaluationInputState = {
    input: {
        evaSupport: null,
        evaManager: null,
        evaBroker: null,
    } as FixtureEvaluationInputModel,
    selectedFixtureId: "",
    showEvaluationInputPanel: false,
}

export const FixtureEvaluationInputSlice = createSlice({
    name: "FixtureEvaluationInput",
    initialState,
    reducers: {
        setEvaluationFixtureInputId: (state, action: PayloadAction<string>) => {
            state.selectedFixtureId = action.payload;
        },
        setFixtureEvaluationInput: (state, action: PayloadAction<FixtureEvaluationInputModel>) => {
            state.input = action.payload;
        },
        setEvaSupport: (state, action: PayloadAction<number>) => {
            state.input.evaSupport = action.payload;
        },
        setEvaManager: (state, action: PayloadAction<number>) => {
            state.input.evaManager = action.payload;
        },
        setEvaBroker: (state, action: PayloadAction<number>) => {
            state.input.evaBroker = action.payload;
        },
        setShowEvaluationInputPanel: (state, action: PayloadAction<boolean>) => {
            state.showEvaluationInputPanel = action.payload;
        },
    }
});

export const FixtureEvaluationInputSelector = createSelector(
    (state: RootState) => state.fixtureEvaluationInput,
    (data) => data
);

export const {
    setEvaluationFixtureInputId,
    setFixtureEvaluationInput,
    setEvaSupport,
    setEvaManager,
    setEvaBroker,
    setShowEvaluationInputPanel
} = FixtureEvaluationInputSlice.actions;

export default FixtureEvaluationInputSlice.reducer;